import * as React from "react";
import { Dimensions, View, StyleSheet, TouchableOpacity } from "react-native";
import { Card, CardItem, Text, Input, CheckBox, Toast } from "native-base";
import { Col, Grid } from "react-native-easy-grid";
import { currentLanguage } from "../../translations/CurrentLanguage";

import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
let strings = new LocalizedStrings(translation);
const editingOnlyOnPress = function() {
  const { isEditing, onPress } = this;
  if (isEditing) {
    onPress();
  } else {
    Toast.show({
      text: strings.PleaseClickTheEditButton,
      buttonText: strings.Okay,
    });
  }
};

const SettingsCheckBox = props => {
  const { text, checked, isEditing, first = false } = props;
  const cardItemStyle = first
    ? styles.cardItemForm
    : [styles.cardItemForm, styles.followingCheck];
  return (
    <CardItem style={cardItemStyle}>
      <View style={styles.checkBoxView}>
        <CheckBox
          style={styles.checkBox}
          checked={checked}
          color={isEditing ? "#2563eb" : "#cfcfcf"}
          onPress={editingOnlyOnPress.bind(props)}
        />
        <Text>{text}</Text>
      </View>
    </CardItem>
  );
};

const HelpText = props => <Text style={styles.helpText}>{props.text}</Text>;

class QueueComponent extends React.PureComponent {
  renderInput() {
    const {
      hasTailOrder,
      queueHost,
      setQueueHost,
      isEditingQueue,
    } = this.props;
    strings.setLanguage(currentLanguage().companyLanguage);

    return (
      <CardItem style={styles.cardItemForm}>
        <View style={styles.view}>
          <Text style={styles.text}>{strings.HostAddress}</Text>
          <Input
            disabled={!hasTailOrder || !isEditingQueue}
            style={isEditingQueue ? styles.inputEnabled : styles.input}
            value={queueHost}
            onChangeText={setQueueHost}
          />
        </View>
      </CardItem>
    );
  }

  render() {
    const {
      isEditingQueue,
      onQueueSave,
      setQueueEditing,
      useDescription,
      toggleUseDescription,
      useDefaultCustomer,
      toggleUseDefaultCustomer,
      hasTailOrder,
      toggleTailOrder,
      isStackItem,
      toggleIsStackItem,
    } = this.props;

    return (
      <View>
        <Card style={styles.card}>
          <CardItem style={styles.cardItem}>
            <Grid>
              <Col style={styles.col}>
                <Text style={styles.titleText}>{strings.OtherSettings}</Text>
              </Col>
              <Col>
                <View style={styles.colView}>
                  <TouchableOpacity onPress={setQueueEditing}>
                    <Icon size={30} name="pencil" style={styles.icon} />
                  </TouchableOpacity>
                  <TouchableOpacity onPress={onQueueSave}>
                    <Icon size={30} name="content-save" style={styles.icon} />
                  </TouchableOpacity>
                </View>
              </Col>
            </Grid>
          </CardItem>
          <SettingsCheckBox
            text={strings.UseDescription}
            checked={useDescription}
            onPress={toggleUseDescription}
            isEditing={isEditingQueue}
          />
          <HelpText text={strings.DescriptiveItemNamesInTheListing} />
          <SettingsCheckBox
            text={strings.UseDefaultCustomer}
            checked={useDefaultCustomer}
            onPress={toggleUseDefaultCustomer}
            isEditing={isEditingQueue}
          />
          <SettingsCheckBox
            text={strings.SetItemStacking}
            checked={isStackItem}
            onPress={toggleIsStackItem}
            isEditing={isEditingQueue}
          />
          <SettingsCheckBox
            text={strings.Use + " TailOrder"}
            checked={hasTailOrder}
            onPress={toggleTailOrder}
            isEditing={isEditingQueue}
          />
          <HelpText
            text={strings.EnableThe + " TailOrder `" + strings.Feature}
          />
          {this.renderInput()}
        </Card>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  input: {
    height: 44,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#d5dbe5",
    backgroundColor: "#f8fafc",
  },
  inputEnabled: {
    height: 44,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#2563eb",
    backgroundColor: "#fff",
  },
  view: {
    flex: 1,
  },
  text: {
    fontWeight: "bold",
    marginBottom: 10,
  },
  card: {
    width: "100%",
    alignSelf: "center",
  },
  cardItem: {
    marginBottom: 15,
    backgroundColor: "#fff",
    borderBottomWidth: 1,
    borderBottomColor: "#e3e8ef",
  },
  col: {
    alignSelf: "center",
  },
  colView: {
    flexDirection: "row",
    alignSelf: "flex-end",
  },
  titleText: {
    color: "#0f172a",
    fontSize: 20,
    fontWeight: "bold",
  },
  checkBox: {
    left: 0,
    marginRight: 10,
  },
  checkBoxView: {
    flexDirection: "row",
  },
  cardItemForm: {
    paddingVertical: 5,
  },
  icon: {
    color: "#2563eb",
    marginLeft: 10,
  },
  helpText: {
    color: "#a7a7a7",
    left: 17,
  },
  followingCheck: {
    marginTop: 10,
  },
});

export default QueueComponent;
